import { apiClient, clean } from "./apiClient";
import type { PageRequest, PageResponse } from "@/types/api";
import type { DocumentFilter, DocumentSummary } from "@/types/entities";

export const documentsService = {
  list(filter: DocumentFilter, page: PageRequest): Promise<PageResponse<DocumentSummary>> {
    return apiClient
      .get<PageResponse<DocumentSummary>>("/documents", { params: { ...clean(filter), ...clean(page) } })
      .then((r) => r.data);
  },
  getOne: (id: string) =>
    apiClient.get(`/documents/${id}`).then((r) => r.data),
  update: (id: string, body: unknown) =>
    apiClient.patch(`/documents/${id}`, body).then((r) => r.data),
  remove: (id: string) =>
    apiClient.delete(`/documents/${id}`),
};